import { render, staticRenderFns } from "./DsbConfirmationModal.vue?vue&type=template&id=2e25ee26"
import script from "./DsbConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DsbConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./DsbConfirmationModal.vue?vue&type=style&index=0&id=2e25ee26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports